// @ts-nocheck
import { CouponState } from '@tencent/wphk-act-base-types';
import { ref } from 'vue-demi';
import Accordion from '../components/accordion/accordion.vue';
import { i18n } from '../i18n';

export const useAccordion = () => {
  const accordionRef = ref<InstanceType<typeof Accordion> | null>(null);
  const checkCouponStates = (fixedCouponDetailList: any[]) => {
    const couponStateUsed = fixedCouponDetailList.every(item => item.couponState === CouponState.used);
    const couponStateExpired = fixedCouponDetailList.every(item => item.couponState === CouponState.expired);
    // eslint-disable-next-line max-len
    const couponStateUsedOrExpired = fixedCouponDetailList.every(item => [CouponState.used, CouponState.expired].includes(item.couponState));
    return { couponStateUsed, couponStateExpired, couponStateUsedOrExpired };
  };
  const getStateText = (fixedCouponDetailList) => {
    const { couponStateUsed, couponStateExpired, couponStateUsedOrExpired } = checkCouponStates(fixedCouponDetailList);
    let stateText = '';
    if (couponStateUsed) {
      stateText = i18n('已使用');
    } else if (couponStateExpired) {
      stateText = i18n('已过期');
    } else if (couponStateUsedOrExpired) {
      stateText = i18n('已使用或已过期');
    }
    return stateText;
  };
  const processAccordion = (titleForFixed, fixedCouponDetailList, isSupportAccordion) => {
    const stateText = getStateText(fixedCouponDetailList);
    if (isSupportAccordion && stateText) {
      const title = i18n('你的') + titleForFixed + stateText;
      // 设置折叠头信息
      accordionRef.value?.setTitleInfo(title);
    } else {
      // 隐藏折叠头
      accordionRef.value?.toggleAccordionHeader(false);
      // 展示扫码券礼包模块
      accordionRef.value?.toggleAccordion(true);
    }
  };
  return {
    accordionRef,
    processAccordion,
  };
};
